/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import { useDispatch } from 'react-redux';

import { pushGTMAnalytic } from '../../../../analytics/GoogleTagManager/GTMActions';
import GTMOperations from '../../../../analytics/GoogleTagManager/GTMOperations';
import {
    EGTMBasketSectionType,
    EGTMBasketValueType,
} from '../../../../analytics/GoogleTagManager/GTMOperations/GTMBasketOperations';
import { modalOpen } from '../../../../modal/modalActions';
import { IModalRenderProps } from '../../../../modal/types/modalTypes';
import TableBasketModal from './BasketModal';

interface IBasketGTMProps {
    sectionType: EGTMBasketSectionType;
    valueType: EGTMBasketValueType;
}

export interface IUseBasketModalOpen {
    gtm?: IBasketGTMProps;
}

export const useBasketModalOpen = ({ gtm }: IUseBasketModalOpen) => {
    const dispatch = useDispatch();

    const onCloseCallback = () => {
        if (gtm) {
            dispatch(pushGTMAnalytic({
                operation: GTMOperations.basket.onBasketButtonClick(gtm.sectionType),
                withAccountType: true,
                withSusrId: true,
                withUserRole: true,
            }));
        }
    };

    const open = (title: string) => {
        dispatch(modalOpen({
            onCloseCallback,
            render: ({ onCloseModal }: IModalRenderProps) => <TableBasketModal
                title={title}
                onCloseModal={onCloseModal}
            />,
        }));
    };

    return { open };
};
